import * as React from 'react';
import { connect } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { patchAdministrationUtilisateur } from 'utils/posters';

import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import { green } from '@mui/material/colors';

const styleButton = {
    margin: '8px 0px 8px 16px'
}

const styleButtonProgress = {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
}

const styleActionContainer = theme => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'row-reverse',
    marginBottom: theme.spacing(3)
})

const styleLink = theme => ({
    textDecoration: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
        color: theme.palette.secondary.main
    }
})

const LinkBreadscumbs = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/getting-started/installation/" {...props} />
));
LinkBreadscumbs.displayName = "LinkBreadscumbs";


const AdministrationUtilisateur = ({ utilisateur, loading, patchAdministrationUtilisateur }) => {

    // Hook Exclusion du contrôle de l'age de la pièce
    const [excluAgePieceChecked, setExcluAgePieceChecked] = React.useState(utilisateur.exclusionControleAgePiece);

    // Handler de l'état de 'excluAgePieceChecked'
    const handleChange = (event) => {
        setExcluAgePieceChecked(event.target.checked);
    }

    // Handler enregistrement des modifications
    const handleSave = () => {
        if (utilisateur && utilisateur.id !== 0)
            var result = patchAdministrationUtilisateur(utilisateur.id, excluAgePieceChecked);
    }

    return (
        <>
            <Helmet>
                <title>{`Utilisateur : ${utilisateur.codePO} - ${utilisateur.nom}`}</title>
            </Helmet>

            <Typography gutterBottom variant="h5">
                Édition de l'utilisateur : {utilisateur.codePO} - {utilisateur.nom}
            </Typography>


            <Breadcrumbs separator="›" arial-label="breadcrumb">
                <Link
                    component={LinkBreadscumbs}
                    to={`/administration/utilisateurs-table/`}
                    sx={styleLink}
                >
                    <Typography variant="button">
                        Utilisateurs
                    </Typography>
                </Link>

                <Typography color="textPrimary">{utilisateur.codePO} - {utilisateur.nom}</Typography>
            </Breadcrumbs>

            <Paper
                sx={{
                    p: theme => theme.spacing(2),
                    mb: theme => theme.spacing(3),
                    mt: theme => theme.spacing(1),
                    height: 400,
                    overflow: 'auto'
                }}
            >
                <Typography gutterBottom variant="h6">
                    Infos générales
                </Typography>

                <Box sx={{ ml: 2 }}>
                    {utilisateur.administrateur &&
                        <Typography component='div' gutterBottom>
                            <Box fontWeight='fontWeightMedium' display='inline'>Administrateur : </Box>{utilisateur.administrateur ? "Oui" : "Non"}
                        </Typography>}

                    {utilisateur.codeDepot &&
                        <Typography component='div' gutterBottom>
                            <Box fontWeight='fontWeightMedium' display='inline'>Code dépôt : </Box>{utilisateur.codeDepot}
                        </Typography>}

                    {utilisateur.depots &&
                        <Typography component='div' gutterBottom>
                            <Box fontWeight='fontWeightMedium' display='inline'>Dépôts : </Box>
                            <ul>
                                {utilisateur.depots.map(depot => {
                                    return (<li key={depot.code}>
                                        {`  ${depot.code} - ${depot.nom}`}
                                    </li>);                                
                                })}
                            </ul>
                        </Typography>}

                    <Typography component='div' gutterBottom>
                        <Box fontWeight='fontWeightMedium' display='inline'>Autoriser SAV : </Box>{utilisateur.autoriseSAV ? "oui" : "Non"}
                    </Typography>


                    {utilisateur.groupes &&
                        <>
                            <Typography component='div' gutterBottom>
                                <Box fontWeight='fontWeightMedium' display='inline'>Groupes :</Box>
                            </Typography>

                            <Stack direction={"column"} spacing={1} sx={{ ml: 2 }}>

                                {utilisateur.groupes.map((groupe, index) => (
                                    <Typography component='div' key={groupe.id}>
                                        {groupe.libelle}
                                        {groupe.admin && <Chip label="Administrateur" variant="outlined" size="small" sx={{ ml: 2 }} />}
                                        {groupe.pilote && <Chip label="Pilote" variant="outlined" size="small" sx={{ ml: 2 }} />}

                                    </Typography>
                                ))}

                            </Stack>
                        </>
                    }
                </Box>
            </Paper >

            <Paper
                sx={{
                    p: theme => theme.spacing(2),
                    mb: theme => theme.spacing(3),
                    mt: theme => theme.spacing(1)
                }}
            >
                <Typography gutterBottom variant="h6">
                    Paramètres
                </Typography>

                <FormControlLabel
                    control={
                        <Switch
                            id="exclusionControleAgePiece"
                            name="exclusionControleAgePiece"
                            checked={excluAgePieceChecked}
                            onChange={handleChange}
                            color="secondary"
                        />
                    }
                    label="Exclusion du contrôle de l'âge d'une pièce : "
                    labelPlacement="start"
                />
            </Paper >

            <Box sx={styleActionContainer}  >
                <Link >
                    <Button
                        sx={styleButton}
                        onClick={() => handleSave()}
                        variant="contained"
                        color="secondary"
                    >
                        Enregistrer

                        {loading && <CircularProgress size={24} sx={styleButtonProgress} />}
                    </Button>
                </Link>

                <RouterLink to={`/administration/utilisateurs-table/`}>
                    <Button
                        sx={styleButton}
                        color="primary"
                    >
                        Annuler
                    </Button>
                </RouterLink>
            </Box>
        </>
    )
}

const mapDispatchToProps = {
    patchAdministrationUtilisateur
};

export default connect(null, mapDispatchToProps)(AdministrationUtilisateur);